/**
 * 상점 / 벌점 조회
 */
import React, { Component } from 'react';
import { Navbar, Form, Modal, Button, InputGroup, Row, Col, ListGroup } from 'react-bootstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import enUS from 'date-fns/locale/en-US';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faSearch, faArrowCircleLeft, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { udfAutoLogin, url, udfInlineLoading, udfNoneLoading, openAlert } from '../../common/common';
import { ruleInfo as getRuleInfo, udfSetLastCdInfo, stdtInfo as getStdtInfo, teacherInfo as getTeacherInfo } from '../../common/usr/stdtList';
import loader from '../../imgs/ajax-loader.gif';
import $ from 'jquery';
import SideMenuCmp from './SideMenuCmp';
import { dropByCacheKey } from 'react-router-cache-route'

registerLocale('enUs', enUS);

const recordCountPerPage = 10;	// 한번에 불러 올 레코드 개수
let firstIndex = 0;	// 불러 올 시작 레코드
let isMore = true;	// 불러 올 레코드 존재 여부
let isRunning = false;

let activeModalId = '';

let that = this;

let old_POINT = 0;

class StdtRuleInfoCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: getRuleInfo.RL_SEQ === 0 ? '' : 'disabled',

      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

      ruleInfo: getRuleInfo,
      stdtInfo: getStdtInfo,
      teacherInfo: getTeacherInfo,
      validated: false,

      // 교사 modal
      teacherAlertShow: false,
      teacherList: [],
      searchKeyword: '',

      // 내용 modal
      rlAlertShow: false,
      CLList: [],
      rlList: [],
      SF_CL_CD: '',
      SF_RL_searchKeyword: '',

      sendNoList: getRuleInfo.sendNoList !== undefined ? getRuleInfo.sendNoList : [],
      SEND_NO: getRuleInfo.SEND_NO,
      COIN: getRuleInfo.COIN,

      NTC_CD: getRuleInfo.COIN > 0 ? getRuleInfo.NTC_CD : '',
      MSG: getRuleInfo.COIN > 0 ? getRuleInfo.MSG : '',

      usrInfo: null,
      clGuNm: { B: '상점', R: '벌점', G: '회복', S: '차감' },
    }
  }

  componentWillMount = () => {
    $(window).scrollTop(0);

    old_POINT = getRuleInfo.POINT;

    this.setState({
      ruleInfo: getRuleInfo,
      disabled: getRuleInfo.RL_SEQ === 0 ? '' : 'disabled',
    });
  }

  componentDidMount = () => {
    // 자동 로그인 체크
    udfAutoLogin(this).then((data) => {
      if (data !== null && data.userSe === 'STDT') {
        this.props.history.push('/stdt/ruleList');
      } else if (data !== null && data.userSe === 'USR') {
        this.setState({ usrInfo: data, clGuNm: { B: data.BLUE_NM, R: data.RED_NM, G: '회복', S: '차감' } });
      } else {
        this.props.history.push('/');
      }
    });

    window.addEventListener('scroll', this.modalHandleScroll);
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.modalHandleScroll);
  }

  componentDidUpdate = () => {
    // modal 출력 순서에 따른 backdrop z-index 처리
    $.each($('.modal-backdrop'), function (i, v) {
      if (i > 0) {
        $(v).css('z-index', $($('.modal')[i - 1]).css('z-index'));
      }
    });

    const { teacherAlertShow, rlAlertShow } = this.state;
    activeModalId = 'teacherModalBody';
    let flag = teacherAlertShow;
    if (rlAlertShow) {
      activeModalId = 'rlModalBody';
      flag = rlAlertShow;
    }

    if (flag) {
      document.getElementById(activeModalId).addEventListener('scroll', this.modalHandleScroll);
    }
  }

  modalHandleScroll = () => {
    const { rlAlertShow } = this.state;
    let bodyId = 'teacherModalBody';
    if (rlAlertShow) bodyId = 'rlModalBody';

    if ($('#' + bodyId)[0] !== undefined &&
      Math.ceil($('#' + bodyId).scrollTop() + $('#' + bodyId).innerHeight()) >= $('#' + bodyId)[0].scrollHeight &&
      isMore) {
      if (rlAlertShow) this.fn_searchRL('N', '');
      else this.fn_searchTeacher('N');
    }
  }

  removeEventValue = () => {
    if (document.getElementById(activeModalId) !== null) {
      document.getElementById(activeModalId).removeEventListener('scroll', this.modalHandleScroll);
      firstIndex = 0;
      isMore = true;
      isRunning = false;
    }
  }

  // bootstrap Alert
  // 닫기 버튼 기본 활성화
  alertClose = (key) => {
    this.removeEventValue();
    this.setState({
      [key]: false,
      // 검색 조건 초기화
      SF_CL_CD: '',
      SF_RL_searchKeyword: '',
      searchKeyword: ''
    });
  }

  // form submit
  handleSubmit(event) {
    const form = event.currentTarget;

    event.preventDefault();
    event.stopPropagation();

    if (this.state.ruleInfo.ONLY_SELF_YN === 'Y') {
      if (this.state.stdtInfo.HAKGWA !== this.state.teacherInfo.HAKGWA ||
        this.state.stdtInfo.GRADE !== this.state.teacherInfo.GRADE ||
        this.state.stdtInfo.BAN !== this.state.teacherInfo.BAN) {
        openAlert(this, '선택한 지도 항목은 담임 선생님만 추가 등록 가능합니다.');
        return;
      }
    } else {
      if (this.state.ruleInfo.SELF_YN === 'N' &&
        this.state.stdtInfo.HAKGWA === this.state.teacherInfo.HAKGWA &&
        this.state.stdtInfo.GRADE === this.state.teacherInfo.GRADE &&
        this.state.stdtInfo.BAN === this.state.teacherInfo.BAN) {
        openAlert(this, '선택한 지도 항목은 담임 선생님이 지도 할 수 없습니다.');
        return;
      }
    }

    if (/[^0123456789.]/g.test(this.state.ruleInfo.POINT)) {
      openAlert(this, '숫자가 아닙니다.\n\n0-9의 정수만 허용합니다.');

      this.setState({
        ruleInfo: {
          ...this.state.ruleInfo,
          POINT: '',
        }
      });

      return false;
    }

    if (form.checkValidity()) {
      that = this;

      // 신규 입력인 경우, 당일 중복 지도 체크
      // if (this.state.ruleInfo.RL_SEQ !== undefined && this.state.ruleInfo.RL_SEQ !== '' && this.state.ruleInfo.RL_SEQ === 0)
      this.fn_chkRldplcnt();
      //else this.fn_update();
    }

    this.setState({ validated: true });
  }

  // 0 채우기
  fn_fillZero = (val, length) => {
    let addZero = '';

    val = val.toString();

    if (val.length < length) {
      const diff = length - val.length;
      for (let i = 0; i < diff; i++) addZero += '0';
    }

    return addZero + val;
  }

  // change date picker value
  handleChange = (date) => {
    this.setState({
      ruleInfo: {
        ...this.state.ruleInfo,
        RL_DATE: date.getFullYear() + '-' + this.fn_fillZero(date.getMonth() + 1, 2) + '-' + this.fn_fillZero(date.getDate(), 2)
      }
    });
  }

  // change form value
  handleInputChange = (target, ruleInfoYN) => {
    if (ruleInfoYN === 'Y') {
      if (target.name === 'RL_TIME') {
        $('input[name=I_RL_TIME]').val(target.value);

        this.setState({
          ruleInfo: {
            ...this.state.ruleInfo,
            [target.name]: target.value,
          }
        });
      } else {
        this.setState({
          ruleInfo: {
            ...this.state.ruleInfo,
            [target.name]: target.value
          }
        });
      }
    } else {
      this.setState({
        [target.name]: target.value
      });
    }
  }

  // 교사 조회
  fn_searchTeacher = (clearYn) => {
    if (!this.state.usrInfo) return;

    if (this.state.usrInfo && this.state.usrInfo.GT_EDIT_YN !== "Y") {
      openAlert(this, "교사를 수정할 수 있는 권한이 없습니다.");
      return;
    }

    if (clearYn === 'Y') {
      firstIndex = 0;
      isMore = true;
      $(window).scrollTop(0);
    }

    that = this;

    if (isMore && !isRunning) {
      isRunning = true;
      udfInlineLoading();

      $.ajax({
        url: url + '/sli/rule/selectTeacherListPUP.do',
        type: 'GET',
        dataType: 'jsonp',
        data: {
          isMobile: 'Y',
          firstIndex: firstIndex,
          recordCountPerPage: recordCountPerPage,
          searchKeyword: that.state.searchKeyword,
        },
        success: function (data) {
          udfNoneLoading();
          if (!data.success)
            that.componentDidMount();
          else {
            let teacherList = [];

            if (data.resultList !== undefined && data.resultList !== '') {
              var idx = firstIndex;
              $.each(data.resultList, function (i, val) {
                idx++;

                teacherList.push({
                  ESNTL_ID: val.ESNTL_ID,
                  EMPLYR_ID: val.EMPLYR_ID,
                  GRADE: val.GRADE,
                  BAN: val.BAN,
                  HAKGWA: val.HAKGWA,
                  ETC: val.ETC,
                });
              });
            }

            if (idx - firstIndex !== recordCountPerPage) isMore = false;
            firstIndex += recordCountPerPage;

            if (clearYn === 'N') teacherList = that.state.teacherList.concat(teacherList);

            isRunning = false;

            that.setState({
              isLoggedIn: true,
              teacherList: teacherList,
              teacherAlertShow: true
            });
          }
        },
        error: function (jqXHR, status, error) {
          isRunning = false;
          udfNoneLoading();
          that.componentDidMount();
        }
      });
    }
  }

  // 교사 선택
  fn_select_teacher = (data) => {
    this.removeEventValue();
    this.setState({
      teacherAlertShow: false,
      ruleInfo: {
        ...this.state.ruleInfo,
        ESNTL_ID: data.ESNTL_ID,
        ESNTL_NM: data.EMPLYR_ID
      }
    });
  }

  // 지도(상벌점) 항목 조회
  fn_searchRL = (clearYn, v_CL_CD) => {
    if (!this.state.usrInfo) return;
    if (this.state.disabled !== '') {
      return;
    }

    if (v_CL_CD != '') {
      this.setState({
        SF_CL_CD: v_CL_CD
      });
    }

    if (clearYn === 'Y') {
      firstIndex = 0;
      isMore = true;
      $(window).scrollTop(0);
    }

    that = this;

    if (isMore && !isRunning) {
      isRunning = true;
      udfInlineLoading();

      $.ajax({
        url: url + '/sli/rule/selectRLListPUP.do',
        type: 'GET',
        dataType: 'jsonp',
        data: {
          isMobile: 'Y',
          firstIndex: firstIndex,
          recordCountPerPage: recordCountPerPage,
          SF_CL_CD: v_CL_CD == '' && that.state.SF_CL_CD != '' ? that.state.SF_CL_CD : v_CL_CD,
          searchKeyword: $('input[name="SF_RL_searchKeyword"]').val()
        },
        success: function (data) {
          udfNoneLoading();

          if (!data.success)
            that.componentDidMount();
          else {
            let resultList = [];

            if (data.resultList !== undefined && data.resultList !== '') {
              var idx = firstIndex;
              $.each(data.resultList, function (i, val) {
                idx++;

                resultList.push({
                  CL_GU: val.CL_GU,
                  CL_GU_NM: that.state.clGuNm[val.CL_GU],
                  CL_NM: val.CL_NM,
                  CL_CD: val.CL_CD,
                  RL_CD: val.RL_CD,
                  RL_DESC: val.RL_DESC,
                  POINT: val.POINT,
                  SELF_YN: val.SELF_YN,
                  ONLY_SELF_YN: val.ONLY_SELF_YN
                });
              });
            }

            if (idx - firstIndex !== recordCountPerPage) isMore = false;
            firstIndex += recordCountPerPage;

            let cllist = [];
            if (data.CLList !== undefined && data.CLList !== '') {
              $.each(data.CLList, function (i, val) {
                cllist.push({
                  CL_CD: val.CL_CD,
                  CL_NM: val.CL_NM,
                  CL_GU: val.CL_GU,
                  CL_GU_NM: that.state.clGuNm[val.CL_GU],
                });
              });
            }

            if (clearYn === 'N') resultList = that.state.rlList.concat(resultList);

            that.setState({
              rlList: resultList,
              CLList: cllist,
              rlAlertShow: true
            });
          }

          isRunning = false;
        },
        error: function (jqXHR, status, error) {
          isRunning = false;
          udfNoneLoading();
          that.componentDidMount();
        }
      });
    }
  }

  // 지도(상벌점) 선택
  fn_select_rl = (data) => {
    if (data.ONLY_SELF_YN === 'Y') {
      if (this.state.stdtInfo.HAKGWA !== this.state.teacherInfo.HAKGWA ||
        this.state.stdtInfo.GRADE !== this.state.teacherInfo.GRADE ||
        this.state.stdtInfo.BAN !== this.state.teacherInfo.BAN) {
        openAlert(this, '선택한 지도 항목은 담임 선생님만 추가 등록 가능합니다.');
        return;
      }
    } else {
      if (data.SELF_YN === 'N' &&
        this.state.stdtInfo.HAKGWA === this.state.teacherInfo.HAKGWA &&
        this.state.stdtInfo.GRADE === this.state.teacherInfo.GRADE &&
        this.state.stdtInfo.BAN === this.state.teacherInfo.BAN) {
        openAlert(this, '선택한 지도 항목은 담임 선생님이 지도 할 수 없습니다.');
        return;
      }
    }

    udfSetLastCdInfo({
      CL_GU: data.CL_GU,
      CL_GU_NM: this.state.clGuNm[data.CL_GU],
      CL_CD: data.CL_CD,
      RL_CD: data.RL_CD,
      RL_DESC: data.RL_DESC,
      POINT: data.POINT,
      CLRL_CD: data.CL_CD + data.RL_CD,
      OLD_CL_CD: data.CL_CD,
      OLD_RL_CD: data.RL_CD,
      SELF_YN: data.SELF_YN,
      ONLY_SELF_YN: data.ONLY_SELF_YN,
    });

    this.removeEventValue();
    this.setState({
      rlAlertShow: false,
      ruleInfo: {
        ...this.state.ruleInfo,
        CL_GU: data.CL_GU,
        CL_GU_NM: this.state.clGuNm[data.CL_GU],
        CL_CD: data.CL_CD,
        RL_CD: data.RL_CD,
        RL_DESC: data.RL_DESC,
        POINT: data.POINT,
        CLRL_CD: data.CL_CD + data.RL_CD,
        OLD_CL_CD: data.CL_CD,
        OLD_RL_CD: data.RL_CD,
        SELF_YN: data.SELF_YN,
        ONLY_SELF_YN: data.ONLY_SELF_YN,
      }
    });
  }

  // 당일 중복 지도 가능여부 체크
  fn_chkRldplcnt = () => {
    if (!this.state.usrInfo) return;

    udfInlineLoading();

    const data = {
      isMobile: 'Y',
      STD_CD: this.state.stdtInfo.STD_CD,
      CL_CD: this.state.ruleInfo.CL_CD,
      RL_CD: this.state.ruleInfo.RL_CD,
      RL_DATE: this.state.ruleInfo.RL_DATE,
      ESNTL_ID: this.state.ruleInfo.ESNTL_ID,
      POINT: this.fn_undefinedToInt(this.state.ruleInfo.RL_SEQ) > 0 ? (old_POINT - this.state.ruleInfo.POINT) * -1 : this.state.ruleInfo.POINT,
    };

    that = this;

    let tgtPoint = this.state.ruleInfo.CL_GU === "B" ? this.state.usrInfo.BLUE_MAX : this.state.usrInfo.RED_MAX;

    $.ajax({
      url: url + '/sli/rule/selectRLDplCnt.do',
      type: 'GET',
      dataType: 'jsonp',
      data: data,
      success: function (data) {
        udfNoneLoading();
        if (!data.success)
          that.componentDidMount();
        else {
          // -1 = Unknown error, 1이상 = 당일중복, -3 = 1일1인제한, -4 = 항목건수제한, -5 = 항목점수제한)
          if (data.resultCount > 0) {
            openAlert(that, "당일 중복 불가능.!!");
          } else if (data.resultCount === -3) {
            openAlert(that, "1일1인(" + tgtPoint + "점) 부과제한\n(부과 가능 점수: " + (old_POINT - data.rNumber) + ")");
          } else if (data.resultCount === -4) {
            openAlert(that, "해당 교사 부과가능 (건수) 초과로 입력 제한");
          } else if (data.resultCount === -5 && old_POINT - data.rNumber < that.state.ruleInfo.POINT) {
            openAlert(that, "해당 교사 부과가능 (점수) 초과로 입력 제한\n(부과 가능 점수: " + (old_POINT - data.rNumber) + ")");
          } else if (data.resultCount === 0 || (data.resultCount === -5 && old_POINT - data.rNumber >= that.state.ruleInfo.POINT)) {
            that.fn_update();
          } else {
            openAlert(that, "알 수 없는 오류가 발생했습니다.");
          }
        }
      },
      error: function (jqXHR, status, error) {
        udfNoneLoading();
        that.componentDidMount();
      }
    });
  }

  fn_undefinedToInt = (val) => {
    if (val === undefined || val === '') val = 0;
    return val;
  }

  fn_undefinedToString = (val) => {
    if (val === undefined || val === '') val = '';
    return val;
  }

  // 상벌점 저장
  fn_update = () => {
    if (!this.state.usrInfo) return;

    // 이모지 삭제
    const emojis = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
    if (emojis.test(this.state.ruleInfo.RL_DESC)) {
      openAlert(this, '죄송합니다.\n😅 이모지는 입력할 수 없습니다.');
      return;
    }

    udfInlineLoading();

    const data = {
      STD_CD: this.state.stdtInfo.STD_CD,
      HAKGWA: this.state.stdtInfo.HAKGWA,
      GRADE: this.state.stdtInfo.GRADE,
      BAN: this.state.stdtInfo.BAN,
      BUN: this.state.stdtInfo.BUN,
      RL_DATE: this.state.ruleInfo.RL_DATE,
      RL_SEQ: this.fn_undefinedToInt(this.state.ruleInfo.RL_SEQ),
      RL_TIME: $('input[name=I_RL_TIME]').val(),
      CL_CD: this.state.ruleInfo.CL_CD,
      CL_GU: this.state.ruleInfo.CL_GU,
      RL_CD: this.state.ruleInfo.RL_CD,
      RL_DESC: this.state.ruleInfo.RL_DESC,
      POINT: this.state.ruleInfo.POINT,
      ESNTL_ID: this.state.ruleInfo.ESNTL_ID,
      BATCH_YN: this.state.ruleInfo.BATCH_YN === undefined ? '' : this.state.ruleInfo.BATCH_YN,
      MSG_YN: this.state.ruleInfo.MSG_YN === undefined ? '' : this.state.ruleInfo.MSG_YN,
      MSG_CNT: this.fn_undefinedToInt(this.state.ruleInfo.MSG_CNT),
      JG_DATE: this.state.ruleInfo.JG_DATE === undefined ? '' : this.state.ruleInfo.JG_DATE,
      JG_SEQ: this.fn_undefinedToInt(this.state.ruleInfo.JG_SEQ),
      NTC_CD: this.state.NTC_CD === undefined ? '' : this.state.NTC_CD,
      MSG: this.state.MSG === undefined ? '' : this.state.MSG,
      SEND_NO: this.state.SEND_NO,
      isMobile: 'Y'
    };

    that = this;

    $.ajax({
      url: url + '/sli/rule/updateRuleJSON.do',
      type: 'GET',
      dataType: 'jsonp',
      data: data,
      success: function (data) {
        udfNoneLoading();
        if (!data.success)
          that.componentDidMount();
        else {
          if (data.result === 1) {
            dropByCacheKey('stdtRuleHistoryCachce');
            openAlert(that, '저장되었습니다.', function () {
              that.props.history.go(-1);
            });
          } else {
            openAlert(that, '저장 도중 오류가 발생했습니다.\n다시 시도해주세요.');
          }
        }
      },
      error: function (jqXHR, status, error) {
        udfNoneLoading();
        that.componentDidMount();
      }
    });
  }

  render() {
    const setSendNoList = this.state.sendNoList.map((data, index) => (
      <option value={data.sendNo} key={index}>{data.title}</option>
    ));

    return (
      <>
        <div className='btn-to-top-b1' onClick={() => $(window).scrollTop(0)}><FontAwesomeIcon icon={faAngleUp} /></div>

        <div className='wrap-loading d-none'>
          <img src={loader} alt='로딩 이미지' />
        </div>

        {/* header */}
        <Navbar fixed='top' className='title'>
          <div className='goBackBtn'><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className='btn-home' /></div></div>
          <div>
            {this.state.ruleInfo.RL_SEQ === 0 ? '(추가) ' : '(수정) '}
            {this.state.stdtInfo.HAKGWA}{this.state.stdtInfo.HAKGWA !== undefined ? ' ' + this.state.stdtInfo.GRADE : this.state.stdtInfo.GRADE}-{this.state.stdtInfo.BAN}-{this.state.stdtInfo.BUN} {this.state.stdtInfo.STD_NM}
          </div>
          <SideMenuCmp
            history={this.props.history}
            usrInfo={this.state.usrInfo}
            alertShow={this.state.alertShow}
            alertMessage={this.state.alertMessage}
            alertClickOk={this.state.alertClickOk}
            alertClickYes={this.state.alertClickYes}
            alertClickNo={this.state.alertClickNo}
          />
        </Navbar>

        <div className='container-fluid' style={{ marginBottom: '4rem', marginTop: '65px' }}>
          <Form
            id='ruleFrm'
            className='m-0 p-0'
            noValidate
            validated={this.state.validated}
            onSubmit={e => this.handleSubmit(e)}
          >
            <Row>
              <div className="fullInputGroup col">
                <DatePicker
                  todayButton={'TODAY'}
                  dateFormat='yyyy-MM-dd'
                  locale={enUS}
                  disabled={this.state.disabled !== '' ? true : false}
                  customInput={
                    <Form.Group controlId='RL_DATE'>
                      <Form.Label>일자 {this.state.disabled !== '' ? <span className='text-danger'>(* 수정불가)</span> : ''} </Form.Label>
                      <InputGroup>
                        <Form.Control
                          className='text-center'
                          type='text'
                          aria-describedby='RL_DATE'
                          required
                          value={this.state.ruleInfo.RL_DATE}
                          readOnly
                        />
                        <InputGroup.Append>
                          <InputGroup.Text id='RL_DATE'><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                        </InputGroup.Append>
                        <Form.Control.Feedback type='invalid'>
                          일자를 입력해주세요.
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  }
                  onChange={this.handleChange}
                />
              </div>
            </Row>
            <Form.Group controlId='RL_TIME'>
              <Form.Label>시간</Form.Label>
              <Row className='m-0'>
                <Col className='pl-0'>
                  <Form.Control
                    className='text-center'
                    as='select'
                    aria-describedby='RL_TIME'
                    name='RL_TIME'
                    value={this.state.ruleInfo.RL_TIME}
                    onChange={(e) => this.handleInputChange(e.target, 'Y')}
                  >
                    <option value=''>직접입력</option>
                    <option value='오전06시'>오전06시</option>
                    <option value='오전07시'>오전07시</option>
                    <option value='오전08시'>오전08시</option>
                    <option value='오전09시'>오전09시</option>
                    <option value='오전10시'>오전10시</option>
                    <option value='오전11시'>오전11시</option>
                    <option value='오후12시'>오후12시</option>
                    <option value='오후01시'>오후01시</option>
                    <option value='오후02시'>오후02시</option>
                    <option value='오후03시'>오후03시</option>
                    <option value='오후04시'>오후04시</option>
                    <option value='오후05시'>오후05시</option>
                    <option value='오후06시'>오후06시</option>
                    <option value='오후07시'>오후07시</option>
                    <option value='오후08시'>오후08시</option>
                    <option value='오후09시'>오후09시</option>
                    <option value='오후10시'>오후10시</option>
                    <option value='오후11시'>오후11시</option>
                  </Form.Control>
                </Col>
                <Col className='pr-0'>
                  <Form.Control
                    className='text-center'
                    type='text'
                    name='I_RL_TIME'
                    defaultValue={this.state.ruleInfo.I_RL_TIME}
                  />
                </Col>
              </Row>
            </Form.Group>
            <Form.Group controlId='ESNTL_NM'>
              <Form.Label>교사 {this.state.disabled !== '' ? <span className='text-danger'>(* 수정불가)</span> : ''}</Form.Label>
              <InputGroup>
                <Form.Control
                  className='text-center'
                  type='text'
                  aria-describedby='ESNTL_NM'
                  required
                  value={this.state.ruleInfo.ESNTL_NM}
                  readOnly
                  onClick={() => { if (this.state.disabled === '') this.fn_searchTeacher('Y'); }}
                />
                <InputGroup.Append
                  onClick={() => { if (this.state.disabled === '') this.fn_searchTeacher('Y'); }}>
                  <InputGroup.Text id='ESNTL_NM'><FontAwesomeIcon icon={faSearch} /></InputGroup.Text>
                </InputGroup.Append>
                <Form.Control.Feedback type='invalid'>
                  교사를 선택해주세요.
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
            <Form.Group controlId='CLRL_CD'>
              <Form.Label>행위항목코드 {this.state.disabled !== '' ? <span className='text-danger'>(* 수정불가)</span> : ''}</Form.Label>
              <InputGroup>
                <Form.Control
                  className='text-center'
                  type='text'
                  aria-describedby='CLRL_CD'
                  required
                  value={`${this.state.ruleInfo.CL_CD}${this.state.ruleInfo.RL_CD}`}
                  readOnly
                  onClick={() => this.fn_searchRL('Y', '')}
                />
                <InputGroup.Prepend style={{ width: '60%' }}>
                  <InputGroup.Text
                    id='RL_DESC' style={{ width: '100%' }} onClick={() => this.fn_searchRL('Y', '')}>{this.state.ruleInfo.CL_GU_NM}</InputGroup.Text>
                </InputGroup.Prepend>
                <InputGroup.Append>
                  <InputGroup.Text
                    id='CLRL_CD' onClick={() => this.fn_searchRL('Y', '')}><FontAwesomeIcon icon={faSearch} /></InputGroup.Text>
                </InputGroup.Append>
                <Form.Control.Feedback type='invalid'>
                  행위항목코드를 선택해주세요.
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
            <Form.Group controlId='RL_DESC'>
              <Form.Label>내용</Form.Label>
              <InputGroup>
                <Form.Control
                  as='textarea'
                  rows='3'
                  aria-describedby='RL_DESC'
                  name='RL_DESC'
                  required
                  value={this.state.ruleInfo.RL_DESC}
                  onChange={(e) => this.handleInputChange(e.target, 'Y')}
                />
                <Form.Control.Feedback type='invalid'>
                  내용을 입력해주세요.
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
            {
              this.state.usrInfo && this.state.usrInfo.RATING_GU !== "Z" ?
                <Form.Group controlId='POINT'>
                  <Form.Label>점수</Form.Label>
                  <Form.Control
                    className='text-center'
                    type='number'
                    aria-describedby='POINT'
                    name='POINT'
                    required
                    value={this.state.ruleInfo.POINT}
                    onChange={(e) => this.handleInputChange(e.target, 'Y')}
                    max='99999'
                  />
                  <Form.Control.Feedback type='invalid'>
                    점수(숫자)를 입력해주세요. 최대 5자리, 99999
                  </Form.Control.Feedback>
                </Form.Group>
                : ""
            }
            {
              this.state.COIN > 0 ?
                <Form.Group controlId='SEND_NO'>
                  <Form.Label>발신번호</Form.Label>
                  <Form.Control
                    className='text-center'
                    as='select'
                    aria-describedby='SEND_NO'
                    name='SEND_NO'
                    value={this.state.SEND_NO}
                    onChange={(e) => { this.setState({ SEND_NO: e.target.value }) }}
                  >
                    {setSendNoList}
                  </Form.Control>
                </Form.Group> : null
            }
            <div className='text-secondary' style={{ fontSize: '.9rem' }}>{this.state.ruleInfo.LAST_UPDATE}</div>
            <Button type='submit' className='mt-2 btn btn-height btn-school-life col'>{this.state.ruleInfo.RL_SEQ === 0 ? '추가 ' : '수정 '}저장</Button>
          </Form>
        </div>

        {/* 교사 modal */}
        <Modal
          show={this.state.teacherAlertShow}
          onHide={() => this.alertClose('teacherAlertShow')}
          aria-labelledby='teacher-contained-modal-title-vcenter'
          animation={false}
          backdropClassName='show'
          centered
          className='customModal'
          size='lg'
        >
          <Modal.Header closeButton>
            <Modal.Title id='teacher-contained-modal-title-vcenter'>
              <span className='h5'>교사(교직원) 선택</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body id='teacherModalBody' style={{ padding: '0' }}>
            <InputGroup className='mb-3 pt-2 pl-3 pr-3'>
              <InputGroup.Prepend>
                <InputGroup.Text>교사명</InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                type='text'
                name='searchKeyword'
                aria-describedby='searchKeyword'
                onChange={(e) => this.handleInputChange(e.target, 'N')}
              />
              <InputGroup.Prepend onClick={() => this.fn_searchTeacher('Y')}>
                <InputGroup.Text><FontAwesomeIcon icon={faSearch} /></InputGroup.Text>
              </InputGroup.Prepend>
            </InputGroup>
            <ListGroup variant='flush'>
              {
                this.state.teacherList === null ? null :
                  this.state.teacherList.map((data, idx) => {
                    return (
                      <ListGroup.Item key={idx} onClick={() => this.fn_select_teacher(data)}>
                        {data.EMPLYR_ID}<br />
                        <span className='text-secondary font-weight-bold d-inline-block' style={{ fontSize: '.9rem', marginRight: '10px' }}>학년</span>
                        <span className='text-secondary d-inline-block' style={{ fontSize: '.9rem', marginRight: '10px' }}>{data.GRADE}</span>
                        <span className='text-secondary font-weight-bold d-inline-block' style={{ fontSize: '.9rem', marginRight: '10px' }}>반</span>
                        <span className='text-secondary d-inline-block' style={{ fontSize: '.9rem', marginRight: '10px' }}>{data.BAN}</span>
                        <span className='text-secondary font-weight-bold d-inline-block' style={{ fontSize: '.9rem', marginRight: '10px' }}>학과</span>
                        <span className='text-secondary d-inline-block' style={{ fontSize: '.9rem', marginRight: '10px' }}>{data.HAKGWA}</span>
                        <span className='text-secondary font-weight-bold d-inline-block' style={{ fontSize: '.9rem', marginRight: '10px' }}>비고</span>
                        <span className='text-secondary d-inline-block' style={{ fontSize: '.9rem', marginRight: '10px' }}>{data.ETC}</span>
                      </ListGroup.Item>
                    );
                  })
              }
            </ListGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='link' onClick={() => { this.alertClose('teacherAlertShow') }}>닫기</Button>
          </Modal.Footer>
        </Modal>

        {/* 지도(상벌점) modal */}
        <Modal
          show={this.state.rlAlertShow}
          onHide={() => this.alertClose('rlAlertShow')}
          aria-labelledby='rl-contained-modal-title-vcenter'
          animation={false}
          backdropClassName='show'
          centered
          className='customModal'
          size='lg'
        >
          <Modal.Header closeButton>
            <Modal.Title id='rl-contained-modal-title-vcenter'>
              <span className='h5'>지도 세부항목 선택</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body id='rlModalBody' style={{ padding: '0' }}>
            {
              this.state.CLList.length === 0 ? null :
                this.state.CLList.map((data, idx) => (
                  <Button
                    key={idx}
                    variant={data.CL_GU === "R" ? "danger" : data.CL_GU === "B" ? "primary" : "info"}
                    className="m-1"
                    onClick={() => { this.fn_searchRL('Y', data.CL_CD); }}
                  >
                    {data.CL_NM}
                  </Button>
                ))
            }

            <InputGroup className='mt-2 mb-3 pl-3 pr-3'>
              <InputGroup.Prepend>
                <InputGroup.Text>검색</InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                type='text'
                name='SF_RL_searchKeyword'
                aria-describedby='SF_RL_searchKeyword'
                onChange={(e) => this.handleInputChange(e.target, 'N')}
                className='bg-light text-muted'
              />
              <InputGroup.Prepend onClick={() => this.fn_searchRL('Y', '')}>
                <InputGroup.Text><FontAwesomeIcon icon={faSearch} /></InputGroup.Text>
              </InputGroup.Prepend>
            </InputGroup>

            <ListGroup variant='flush'>
              {
                this.state.rlList.length === 0 ? null :
                  this.state.rlList.map((data, idx) => {
                    return (
                      <ListGroup.Item key={idx} onClick={() => this.fn_select_rl(data)}>
                        <div className='row'>
                          <div className='col-2 pr-0'><span className={data.CL_GU_NM === this.state.usrInfo.BLUE_NM ? 'blue-point' : data.CL_GU_NM === this.state.usrInfo.RED_NM ? 'red-point' : data.CL_GU_NM === '회복' ? 'green-point' : data.CL_GU_NM === '차감' ? 'deduction-point' : ''}>{data.CL_GU_NM}</span></div>
                          <div className='col'>{data.RL_DESC}</div>
                          {
                            this.state.usrInfo && this.state.usrInfo.RATING_GU !== "Z" ?
                              <div className='col-2 point text-right text-nowrap'>
                                <span style={{ fontSize: "1.4rem" }}>{data.POINT}</span> 점
                              </div>
                              : ""
                          }
                        </div>
                        <div className='row'>
                          <div className='col-12'>
                            <span className='text-secondary d-inline-block' style={{ fontSize: '.9rem', marginRight: '10px' }}>{`${data.CL_CD}-${data.RL_CD}`}</span>
                            <span className='text-secondary d-inline-block' style={{ fontSize: '.9rem', marginRight: '10px' }}>{data.CL_NM}</span>
                          </div>
                        </div>
                      </ListGroup.Item>
                    );
                  })
              }
            </ListGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='link' onClick={() => { this.alertClose('rlAlertShow') }}>닫기</Button>
          </Modal.Footer>
        </Modal>

      </>
    );
  }
}

export default StdtRuleInfoCmp;